
const options = [{
    value: '0',
    label: 'No Experience'
}, {
    value: '100',
    label: 'Youth Camps/YMCA Basketball'
}, {
    value: '200',
    label: 'Macker Experience - Youth Only'
}, {
    value: '250',
    label: 'Jr. High/Middle School'
}, {
    value: '350',
    label: 'AAU/AYBT - Travel Teams'
}, {
    value: '400',
    label: 'High School - Freshman'
}, {
    value: '450',
    label: 'High School - Jr. Varsity'
}, {
    value: '500',
    label: 'High School - Varsity Small - Class C/D'
}, {
    value: '550',
    label: 'High School - Varsity Large - Class A/B'
}, {
    value: '600',
    label: 'College Intramurals'
}, {
    value: '625',
    label: 'Adult Rec./Church League'
}, {
    value: '650',
    label: 'College "Club" Team'
}, {
    value: '700',
    label: 'Jr./Community College Div. II/III, NAIA'
}, {
    value: '800',
    label: 'Small College Div. II/III, NAIA'
}, {
    value: '900',
    label: 'Major College Div. I'
}, {
    value: '950',
    label: 'Semi-Professional NBDL/CBA'
}, {
    value: '1000',
    label: 'Professional NBA/European'
}];

const keys = {
    '0': 'No Experience',
    '100':'Youth Camps/YMCA Basketball',
    '200': 'Macker Experience - Youth Only',
    '250': 'Jr. High/Middle School',
    '350': 'AAU/AYBT - Travel Teams',
    '400': 'High School - Freshman',
    '450': 'High School - Jr. Varsity',
    '500': 'High School - Varsity Small - Class C/D',
    '550': 'High School - Varsity Large - Class A/B',
    '600': 'College Intramurals',
    '625': 'Adult Rec./Church League',
    '650': 'College "Club" Team',
    '700': 'Jr./Community College Div. II/III, NAIA',
    '800': 'Small College Div. II/III, NAIA',
    '900': 'Major College Div. I',
    '950': 'Semi-Professional NBDL/CBA',
    '1000': 'Professional NBA/European',
}

const serverKeys = {
    '_0': 'No Experience',
    '_100': 'Youth Camps/YMCA Basketball',
    '_200': 'Macker Experience - Youth Only',
    '_250': 'Jr. High/Middle School',
    '_350': 'AAU/AYBT - Travel Teams',
    '_400': 'High School - Freshman',
    '_450': 'High School - Jr. Varsity',
    '_500': 'High School - Varsity Small - Class C/D',
    '_550': 'High School - Varsity Large - Class A/B',
    '_600': 'College Intramurals',
    '_625': 'Adult Rec./Church League',
    '_650': 'College "Club" Team',
    '_700': 'Jr./Community College Div. II/III, NAIA',
    '_800': 'Small College Div. II/III, NAIA',
    '_900': 'Major College Div. I',
    '_950': 'Semi-Professional NBDL/CBA',
    '_1000': 'Professional NBA/European',
}

export { options, keys, serverKeys }